/**
 * Coerce JSONB / legacy tag values into a string array for API responses and UI.
 */
export function normalizeStringTags(raw) {
    if (raw == null)
        return [];
    if (Array.isArray(raw)) {
        return raw
            .filter((tag) => typeof tag === 'string' && tag.trim().length > 0)
            .map((tag) => tag.trim());
    }
    if (typeof raw === 'string') {
        const trimmed = raw.trim();
        if (!trimmed)
            return [];
        if (trimmed.startsWith('[')) {
            try {
                const parsed = JSON.parse(trimmed);
                return normalizeStringTags(parsed);
            }
            catch {
                return [];
            }
        }
        return trimmed
            .split(',')
            .map((tag) => tag.trim())
            .filter(Boolean);
    }
    return [];
}
//# sourceMappingURL=normalizeStringTags.js.map